module.exports = __webpack_public_path__ + "static/media/ic_ketone.add32ebf.svg";